import axios from 'axios'

const axiosInstance = axios.create({
    baseURL: '/services/plugin-live-multi-company/user-group'
})

const listUserGroupsApi = companyID => {
    return axiosInstance.get('/v2/list', { params: { companyID } })
}

const createUserGroupApi = userGroup => {
    return axiosInstance.post('/', userGroup)
}

const updateUserGroupApi = userGroup => {
    return axiosInstance.put(`/${userGroup.id}`, userGroup)
}

export { listUserGroupsApi, createUserGroupApi, updateUserGroupApi }
